/**
 * @generated SignedSource<<1ee3893071dc5acd3dab48026e6c8232>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TeamIcon = "account_hard_hat" | "account_tie" | "apple" | "baby_carriage" | "baguette" | "basket" | "bed" | "bread_slice" | "broom" | "carrot" | "cart" | "cash" | "cash_register" | "cheese" | "coffe" | "cookie" | "cupcake" | "default" | "desk_lamp" | "dolly" | "fish" | "flower" | "food" | "fork_knife" | "forklift" | "fridge" | "hamburger" | "hammer_wrench" | "laptop" | "market" | "meat" | "milk" | "pineapple" | "soda" | "sofa" | "steak" | "tshirt" | "tv" | "watermelon";
import { FragmentRefs } from "relay-runtime";
export type KPIListInputItem_routineOccasionSection$data = {
  readonly section: {
    readonly assignedTeam: {
      readonly color: string | null;
      readonly icon: TeamIcon | null;
      readonly isPrivate: boolean;
      readonly name: string;
    } | null;
    readonly id: string;
    readonly title: string | null;
  };
  readonly sectionVersion: {
    readonly title: string | null;
  };
  readonly " $fragmentType": "KPIListInputItem_routineOccasionSection";
};
export type KPIListInputItem_routineOccasionSection$key = {
  readonly " $data"?: KPIListInputItem_routineOccasionSection$data;
  readonly " $fragmentSpreads": FragmentRefs<"KPIListInputItem_routineOccasionSection">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "KPIListInputItem_routineOccasionSection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RoutineSectionVersion",
      "kind": "LinkedField",
      "name": "sectionVersion",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoutineSection",
      "kind": "LinkedField",
      "name": "section",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Team",
          "kind": "LinkedField",
          "name": "assignedTeam",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "icon",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "color",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isPrivate",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RoutineOccasionSection",
  "abstractKey": null
};
})();

(node as any).hash = "c8ec4ca9060d0e410aa6107d535ca584";

export default node;
